import { useCuentaContableEmpresaVenta } from "api/CuentaContableEmpresa.hook"
import { useCuentaContableCuentaVenta } from "api/CuentaContable_Cuenta.hook"
import { CATEGORIA_CUENTA_CONTABLE_ENUM } from "api/Types/CategoriaCuentaContableEnum"
import { DropdownCuentasContablesConModal } from "common/components/DropdownsCuentasContables/DropdownCuentasContablesConModal/DropdownCuentasContablesConModal"
import { newDocumentoSettingsSelector } from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import { setCuentaContableFactura } from "features/Crear/redux/slices/newDocumentoSettingsSlice"
import useCuentasContables from "features/Tesoreria/hooks/useCuentasContables"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { DropdownChangeParams } from "primereact/dropdown"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"

const DocumentoSettingsCuentaContable = ({
  cuentaContableRecurrentes,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { getCuentaContablePorDefecto } = useCuentasContables()
  const { cuentasContablesEmpresas: listaDeCuentasBase } =
    useCuentaContableCuentaVenta()
  const {
    cuentasContablesEmpresas: listaDeCuentas,
    cuentasContablesEmpresasRefetch: refresListaDeCuentas,
  } = useCuentaContableEmpresaVenta()

  const initialPorDefectoCuentasVentas = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.VENTA
  )
  const initialPorDefectoPrestamoConcedidoBase = listaDeCuentas?.find(
    (cuentaContableEmpresaBase) => {
      return cuentaContableEmpresaBase?.id === initialPorDefectoCuentasVentas
    }
  )

  const { cuentaContableFactura } = useSelector(newDocumentoSettingsSelector)

  useEffect(() => {
    setCuentaContableFactura(
      cuentaContableRecurrentes?.id ||
        initialPorDefectoPrestamoConcedidoBase?.id
    )
    dispatch(setCuentaContableFactura(cuentaContableRecurrentes))
  }, [
    dispatch,
    cuentaContableRecurrentes,
    initialPorDefectoPrestamoConcedidoBase,
  ])

  return (
    <div className='p-0 mt-3 col p-fluid p-field divisa-container'>
      <p className='text-left'>
        {t("crear.facturaRec.accountingAccountLabel")}
      </p>
      <DropdownCuentasContablesConModal
        cuentasContablesOptions={listaDeCuentas}
        dropdownValue={cuentaContableFactura}
        onChange={(newCuentaContable: DropdownChangeParams) => {
          dispatch(setCuentaContableFactura(newCuentaContable.value))
        }}
        listaDeCuentasBase={listaDeCuentasBase}
        cuentaPorDefecto={initialPorDefectoPrestamoConcedidoBase}
        refreshFetchData={refresListaDeCuentas}
        withCreateCuenta
      />
    </div>
  )
}

export default DocumentoSettingsCuentaContable
